var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeToProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3572 10.7144C19.5088 10.7144 10.7144 19.5088 10.7144 30.3572V69.6429C10.7144 80.4914 19.5088 89.2858 30.3572 89.2858H69.6429C80.4914 89.2858 89.2858 80.4914 89.2858 69.6429V30.3572C89.2858 19.5088 80.4914 10.7144 69.6429 10.7144H30.3572ZM50.0001 30.3572C52.1698 30.3572 53.9286 32.1161 53.9286 34.2858V48.3728L60.6351 55.0793C62.1693 56.6135 62.1693 59.1009 60.6351 60.6351C59.1009 62.1693 56.6135 62.1693 55.0793 60.6351L47.2221 52.778C46.4854 52.0412 46.0715 51.042 46.0715 50.0001V34.2858C46.0715 32.1161 47.8304 30.3572 50.0001 30.3572Z",
    fill: "#4D3ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeToProcess);
export default __webpack_public_path__ + "static/media/timeToProcess.9ccec058d81aa0a0bdcc818422976374.svg";
export { ForwardRef as ReactComponent };